export const CHOOSE_TYPE = 'CHOOSE_TYPE'
export const GET_LANGUAGE = 'GET_LANGUAGE'
export const GET_BMI = 'GET_BMI'
export const CLEAR_BMI = 'CLEAR_BMI' 
export const CLEAR_ALL = 'CLEAR_ALL' 
export const CM_KG = 'Cm & Kg'
export const FEET_POUND = 'Feet & Pound'
export const FEET_STONE = 'Feet & Stone'
export const INCH_STONE = 'Inch & Stone'

